import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { nvStorage } from '@simwood/nv-react-components';
import { finaliseLogout } from '../../shared/store/thunks';

export interface AppState {
  diallerNumber: string;
  dnd: boolean;
  showChangelogRequest?: number;
}

const initialState: AppState = {
  diallerNumber: '',
  dnd: String(nvStorage.get('dnd')) === 'true',
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    diallerNumberSet: (state, action: PayloadAction<{ number: string }>) => {
      const { number } = action.payload;
      state.diallerNumber = number;
    },
    dndSet: (state, action: PayloadAction<boolean>) => {
      nvStorage.set('dnd', action.payload);
      state.dnd = action.payload;
    },
    openChangelog: (state) => {
      state.showChangelogRequest = Date.now();
    },
  },
  extraReducers: (builder) => {
    // Don't carry DND over to whoever logs in next.
    builder.addCase(finaliseLogout.fulfilled, () => {
      nvStorage.remove('dnd');
      return { ...initialState, dnd: false };
    });
  },
});

export const { diallerNumberSet, dndSet, openChangelog } = appSlice.actions;

export default appSlice.reducer;
